import { createPortal } from 'react-dom';
import { ReactNode, useEffect } from 'react';

export default function Portal({ children }: { children: ReactNode }) {
  const mount = document.getElementById('portal-root');
  const el = document.createElement('div');

  useEffect(() => {
    function removeChild() {
      if (mount && el) {
        mount.removeChild(el);
      }
    }

    if (!mount) return removeChild;

    mount.appendChild(el);

    return removeChild;
  }, [el, mount]);

  return createPortal(children, el);
}
